import LabelComponent from 'app_components/commons/LabelComponent/LabelComponent'
import { ILandingTutorialPrivateGroup } from 'app_types/admin/landings/landingTypes'
import { ITerm } from 'app_types/admin/term/term.types'
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react'
import { useForm } from 'react-hook-form'
import './TutorialRoleForm.scss'
import ReactSelectComponent from 'app_components/commons/reactSelect'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import { GrFormAdd } from 'react-icons/gr'
import TooltipComponent from 'app_components/commons/TooltipComponent/TooltipComponent'
import { MdDelete } from 'react-icons/md'

interface ITutorialRoleFormProps {
  terms: ITerm[]
  listOfRoles: any[]
  defaultValue: ILandingTutorialPrivateGroup[]
  onChange: (items: ILandingTutorialPrivateGroup[]) => void
}

const TutorialRoleForm: FC<ITutorialRoleFormProps> = ({ defaultValue, terms, listOfRoles, onChange }) => {
  const placeholderForm = useForm()
  const [privateGroups, setPrivateGroups] = useState<ILandingTutorialPrivateGroup[]>(defaultValue ? defaultValue : [])

  useEffect(() => {
    onChange && onChange(privateGroups)
  }, [privateGroups])

  const groupOptions = useMemo(() => {
    return terms?.map((group) => ({
      label: group.name,
      value: group._id
    }))
  }, [terms])

  const handleChangeRole = useCallback((newRole: any, idx: number) => {
    const newValue = [...privateGroups]
    newValue[idx].role = newRole
    setPrivateGroups(newValue)
  }, [privateGroups])

  const handleChangeGroups = useCallback((newGroups: any, idx: number) => {
    const newValue = [...privateGroups]
    newValue[idx].groups = newGroups
    setPrivateGroups(newValue)
  }, [privateGroups])

  const handleAddPrivateGroup = useCallback(() => {
    const newItem: ILandingTutorialPrivateGroup = {
      groups: [],
      role: listOfRoles[0],
    }
    setPrivateGroups([...privateGroups, newItem])
  }, [privateGroups, listOfRoles])

  const handleClickRemoveGroup = useCallback((idx: number) => {
    const newValue = [...privateGroups]
    newValue.splice(idx, 1)
    setPrivateGroups(newValue)
  }, [privateGroups])

  return (
    <div className="tutorial-role-form--landing">
      <div className="tutorial-role-form--header">
        <TextComponent>
          Grupos privados
        </TextComponent>
        <TooltipComponent text='Agregar grupo privado'>
          <GrFormAdd onClick={handleAddPrivateGroup} />
        </TooltipComponent>
      </div>
      {privateGroups?.map((item: ILandingTutorialPrivateGroup, idx: number) => (
        <div key={idx} className="tutorial-role-form--item">
          <div className="tutorial-role-form--delete-icon" onClick={() => handleClickRemoveGroup(idx)}>
            <TooltipComponent text="Eliminar grupo">
              <MdDelete />
            </TooltipComponent>
          </div>
          <div>
            <LabelComponent>Role</LabelComponent>
            <ReactSelectComponent
              identifier={`role-${idx}`}
              formHooks={placeholderForm}
              options={listOfRoles}
              isMulti={false}
              defaultValue={[item?.role]}
              onChangeSelect={(e: any) => handleChangeRole(e, idx)}
              disableClear
            />
          </div>
          <div>
            <LabelComponent>Grupos</LabelComponent>
            <ReactSelectComponent
              identifier={`groups-${idx}`}
              formHooks={placeholderForm}
              options={groupOptions}
              isMulti={true}
              required={false}
              defaultValue={item.groups}
              onChangeSelect={(e: any) => handleChangeGroups(e, idx)}
            />
          </div>
        </div>
      ))}
    </div>
  )
}

export default TutorialRoleForm
